import { moduleFactory } from "@/factories/module";
import { _generateRandomUuid } from "@/modules/uuid/generation/generate";
import { resolveCapturedAudioId } from "@/modules/uuid/generation/derive";
import { _maybeParseUuidValue } from "@/modules/uuid/strings/maybeParseValue";
import { _parseUuidValue } from "@/modules/uuid/strings/parseValue";
import { _serializeUuid } from "@/modules/uuid/strings/serialize";

export const uuidModule = moduleFactory.create({
  serialize: _serializeUuid,
  parseValue: _parseUuidValue,
  maybeParseValue: _maybeParseUuidValue,
  generate: _generateRandomUuid,
  resolveCapturedAudioId,
});
